'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _sanitizeHtml = require('sanitize-html');

var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOptions = exports.defaultOptions = {
  allowedTags: ['h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol', 'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'br', 'div', 'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre', 'img', 'br', 'hr', 'span', 'iframe', 'sub', 'sup', 'dd', 'dt'],
  allowedAttributes: {
    a: ['href', 'name', 'target'],
    img: ['src', 'alt'],
    iframe: ['src', 'allowfullscreen', 'allow', 'frameborder', 'width', 'height'],
    '*': ['style', 'title']
  },
  selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta'],
  allowedStyles: {
    '*': {
      // Match HEX and RGB
      color: true,
      'text-align': [/^left$/, /^right$/, /^center$/],
      // Match any number with px, em, rem, or %
      'font-size': [/^\d+(?:px|em|rem|%)$/],
      float: true,
      clear: true
    }
  },
  allowedSchemes: ['https', 'ftp', 'mailto', 'tel', 'sms'],
  allowedSchemesByTag: {},
  allowProtocolRelative: true
};

function SanitizeHtml(html, options) {
  var sanitizeOptions = (0, _extends3.default)({}, defaultOptions, options);

  return {
    __html: (0, _sanitizeHtml2.default)(html, sanitizeOptions)
  };
}

exports.default = SanitizeHtml;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/SanitizeHtml.js
// module id = 544
// module chunks = 0